// TODO: Why are we importing random types?
import { IScoringRules } from "@scaleip/nest-api/src/common/types/contacts.type";

import Drawer from "@mui/material/Drawer";

import ScoringForm from "@components/Admin/ScoringForm";

import {
  useGetContactScoringRulesQuery,
  useGetContactsQuery,
  useUpdateContactScoringRulesMutation,
} from "@queries/contact.query";

import { useAdminStore } from "@store/adminStore";
import { useUserStore } from "@store/userStore";

import AdminDrawerStyles from "./AdminDrawerStyles";

export default function AdminDrawer() {
  const { isAdminDrawerOpen, setIsAdminDrawerOpen } = useAdminStore();
  const { data: scoringRules } = useGetContactScoringRulesQuery();
  const { mutateAsync: updateScoringRules, status } = useUpdateContactScoringRulesMutation();
  const { role } = useUserStore();

  const { refetch } = useGetContactsQuery();

  if (!role || role !== "Admin") return null;

  const handleUpdateScoringRules = (newScoringRules: IScoringRules) => {
    if (!scoringRules) return;
    updateScoringRules({
      newScoringRules: {
        createdAt: scoringRules.createdAt,
        id: scoringRules.id,
        scoringRules: newScoringRules,
      },
    })
      .then(async () => {
        setIsAdminDrawerOpen(false);
        await refetch();
      })
      .catch((error) => {
        console.log(error);
      });
  };

  return (
    <div>
      <Drawer
        anchor="right"
        ModalProps={{
          BackdropProps: {
            style: {
              backgroundColor: "rgba(0, 0, 0, 0.7)",
            },
          },
        }}
        onClose={() => setIsAdminDrawerOpen(false)}
        open={isAdminDrawerOpen}
        sx={AdminDrawerStyles.drawer}
        transitionDuration={300}
      >
        {scoringRules && (
          <ScoringForm
            handleUpdateScoringRules={handleUpdateScoringRules}
            isUpdatingScoringRules={status === "pending"}
            scoringRules={scoringRules.scoringRules}
          />
        )}
      </Drawer>
    </div>
  );
}
